<script setup lang="ts">
import LandingPortal from '~/components/landing/LandingPortal.vue'
import ListingPreviewDrawer from '~/components/listing/ListingPreviewDrawer.vue'
import { useClient } from '~/stores/client'

definePageMeta({ layout: false })

const client = useClient()
if (client.isAuthenticated) {
  await navigateTo('/feed', { replace: true })
}

useHead({ title: 'Работа в Новосибирске по видео — вакансии в кафе, ресторанах и магазинах | Sobes' })
useSeoMeta({
  description: 'Вакансии без резюме и без опыта: бариста, официанты, повара, кассиры. Работодатели показывают себя на видео, соискатели отвечают минутой о себе.',
})
</script>

<template>
  <div>
    <LandingPortal />
    <ListingPreviewDrawer />
  </div>
</template>
